"use strict";

var cleanObject = function cleanObject(obj) {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
      delete obj[key];
    }
  });
  return obj;
};
module.exports = {
  cleanObject: cleanObject
};